/**
 * Custom chip text while a client method type is present.
 * Blank values keep the canonical Type chip selected.
 */
export function resolveClientMethodTypeStatusLabel(clientMethodType: string) {
  if (clientMethodType.trim().length === 0) {
    return undefined;
  }
  return clientMethodType;
}
